import { useEffect, useState } from 'react';
import { getAnalyticsClient } from '../../clients/analytics-client';
function getAnalyticsSubproduct(appName, subProduct) {
  if (!subProduct) {
    return appName;
  }
  return `jira-${subProduct}-directory`;
}
export function useSetupAnalyticsClient(cloudId, appName, subProduct) {
  const analyticsSubProduct = getAnalyticsSubproduct(appName, subProduct);
  const [analyticsClient, setAnalyticsClient] = useState(getAnalyticsClient({
    mode: appName,
    subproduct: analyticsSubProduct,
    cloudId
  }));

  // setup analytics object
  useEffect(() => {
    if (!cloudId) {
      return;
    }
    const analytics = getAnalyticsClient({
      mode: appName,
      subproduct: analyticsSubProduct,
      cloudId
    });
    setAnalyticsClient(analytics);
  }, [cloudId, analyticsSubProduct, appName]);

  // TODO: fix-me - currently, cloudId is required to render People app.
  // When analytics client without cloud id is used, Cypress test `dev-packages/cypress/src/specs/analytics.spec.ts` is flaky.
  // It seems that the analytics client without cloud id used first, then analytics client with cloud is replaced, but the app does not re-render in Cypress tests.
  return cloudId ? analyticsClient : undefined;
}